import __request__ from "routing/request";
export function pauseProcessing(requestOptions) {
  return __request__("PUT", "/system/processing/pause", null, {}, {
    "Accept": []
  }, requestOptions);
}
export function resumeProcessing(requestOptions) {
  return __request__("PUT", "/system/processing/resume", null, {}, {
    "Accept": []
  }, requestOptions);
}
